import {
  performerCategoryLabel,
  performerText,
} from "./performerCatalog.js";

// REISOR_PHASE3B_REGISTRATION_COMPLETE_V1

export default function PerformerRegistrationComplete({
  outcome,
  language = "ru",
}) {
  const tx = (ru, uz, tr) =>
    performerText(language, ru, uz, tr);

  const category =
    performerCategoryLabel(
      outcome?.performerCategory,
      language
    );

  const detail =
    outcome?.assetSubtype ||
    outcome?.bodyTypeOther ||
    "";

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "28px 18px",
        background: "#020617",
        color: "#f8fafc",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          padding: 24,
          borderRadius: 22,
          background: "#0f172a",
          border: "1px solid #334155",
        }}
      >
        <div
          style={{
            fontSize: 42,
            marginBottom: 12,
          }}
        >
          ✅
        </div>

        <h2 style={{ margin: "0 0 12px" }}>
          {tx(
            "Профиль создан",
            "Профиль яратилди",
            "Profil oluşturuldu"
          )}
        </h2>

        <div
          style={{
            fontSize: 18,
            fontWeight: 800,
            marginBottom: 12,
          }}
        >
          {category}
          {detail ? ` · ${detail}` : ""}
        </div>

        <p
          style={{
            margin: 0,
            lineHeight: 1.55,
            color: "#cbd5e1",
          }}
        >
          {tx(
            "Телефон подтверждён, категория сохранена. REISOR не будет ошибочно отправлять вам грузовые рейсы.",
            "Телефон тасдиқланди, тоифа сақланди. REISOR сизга хато тарзда юк рейсларини юбормайди.",
            "Telefon doğrulandı ve kategori kaydedildi. REISOR size yanlışlıkla yük işleri göndermeyecek."
          )}
        </p>

        <p
          style={{
            margin: "14px 0 0",
            lineHeight: 1.55,
            color: "#94a3b8",
          }}
        >
          {tx(
            "Регистрация завершена. Можно закрыть это окно.",
            "Рўйхатдан ўтиш якунланди. Бу ойнани ёпишингиз мумкин.",
            "Kayıt tamamlandı. Bu pencereyi kapatabilirsiniz."
          )}
        </p>
      </div>
    </div>
  );
}
